export default {
	id: "",
	src: "",
	shouldShowBottom: false,
	shouldCover: false,
};
